import { Button, Stack } from '@eleveo/components-react';
import { CrossIcon } from '@eleveo/icons-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { DataImportForm } from './DataImportForm';
import { DataImporterPassedProps } from './DataImporter';
import { UPLOAD_FILE_CANCEL_BUTTON_TAG, UPLOAD_FILE_SUBMIT_BUTTON_TAG } from './constants';
import { HistoricalDataInterval } from './utils';
import { SidebarContent, SidebarPanel, SidebarPart } from '../../components/LayoutNext/LayoutNext';
import { SidebarForm } from '../../components/LayoutNext/SidebarForm';

type DataImportSidebarProps = {
  passedProps: DataImporterPassedProps;
  handleCloseSidebar: () => void;
};

type Values = {
  historicalDataInterval: number;
};

export const DataImportSidebar: React.FC<DataImportSidebarProps> = ({
  passedProps: { submitDisabled, cancelDisabled, onCancel, uploadPending, onSubmit, onFileChange, fileName, fileSize },
  handleCloseSidebar,
}) => {
  const { t } = useTranslation();

  const disabled = submitDisabled || uploadPending;

  return (
    <SidebarForm<Values>
      initialValues={{ historicalDataInterval: HistoricalDataInterval.Min15 }}
      onClose={handleCloseSidebar}
      onSubmit={({ historicalDataInterval }) => onSubmit(historicalDataInterval)}
      title={t('dataImport.importDataLabel')}
    >
      {() => (
        <>
          <SidebarPanel>
            <Stack className="w-full">
              <Button testId={UPLOAD_FILE_SUBMIT_BUTTON_TAG} isDisabled={disabled} color="success" type="submit">
                {t('layout.action.upload')}
              </Button>
              <Button
                className="mr-auto"
                isDisabled={cancelDisabled}
                onClick={onCancel}
                testId={UPLOAD_FILE_CANCEL_BUTTON_TAG}
              >
                <CrossIcon />
                {t('form.cancel')}
              </Button>
            </Stack>
          </SidebarPanel>
          <SidebarContent>
            <SidebarPart>
              <DataImportForm disabled={disabled} fileName={fileName} fileSize={fileSize} onFileChange={onFileChange} />
            </SidebarPart>
          </SidebarContent>
        </>
      )}
    </SidebarForm>
  );
};
